import {
  PostMessagePayloadType,
  PostMessageType,
  PostSocialPayloadType,
  postMessageTypeEnum,
  postSocialTypeEnum,
  wsMessageTypeEnum,
} from './useWebsocketTypes';

export function generatePostMessage({
  answered,
  cType,
  dialogs,
  forwarded,
  forwardedn,
  interlocutor,
  messageText,
  pollId,
  selectedChatId,
  uploadFiles,
  users,
}: PostMessageType): PostMessagePayloadType {
  const payload: PostMessagePayloadType = {
    cType,
    ...(selectedChatId != null && { dialog: selectedChatId }),
    ...(selectedChatId == null && interlocutor && { interlocutor }),
    ...(pollId && { pollId }),
    ...(messageText?.trim() && { text: messageText.trim() }),
    ...(cType === wsMessageTypeEnum.callDeclined && { text: ' ' }), // Костыль.
    ...(cType === wsMessageTypeEnum.joinCall && { text: ' ' }), // Костыль.
    ...(cType === wsMessageTypeEnum.aproveJoinCall && { text: ' ' }), // Костыль.
    // При отправке сигнала об отклонении звонка, бэк не пропускает сообщение с пустым полем text
    ...(answered && { answered }),
    ...(users?.length && { users }),
    ...(dialogs?.length && { dialogs }),
    ...(forwarded && { forwarded }),
    ...(forwardedn?.length && { forwardedn }),
    ...(uploadFiles?.length && { files: uploadFiles }),
  };

  return payload;
}

export function generatePostSocial({
  rObjects = [],
  type = postSocialTypeEnum.view,
}: PostMessageType): PostSocialPayloadType {
  const payload: PostSocialPayloadType = {
    rObjects,
    type,
  };
  return payload;
}

export function generatePostPayload({
  answered,
  selectedChatId,
  messageText,
  uploadFiles,
  cType,
  users,
  messageType,
  type,
  rObjects = [],
  dialogs,
  forwarded,
  forwardedn,
  interlocutor,
  pollId,
}: PostMessageType): PostMessagePayloadType | PostSocialPayloadType {
  switch (messageType) {
    case postMessageTypeEnum.message: {
      return generatePostMessage({
        answered,
        cType,
        dialogs,
        forwarded,
        forwardedn,
        interlocutor,
        messageText,
        pollId,
        selectedChatId,
        uploadFiles,
        users,
      });
    }
    case postMessageTypeEnum.social: {
      return generatePostSocial({ rObjects, type });
    }
    default: {
      return { cType: wsMessageTypeEnum.textMessage };
    }
  }
}
